import url from "../config/url";
import axios from "axios";


//TODO:将文章整理优化成函数
// 获取最初的栏目信息
export async function getInit() {
    try {
        const config = {
            method: 'get',
            url: url.main_url,
        };

        const { data } = await axios(config);
        if (data.code === 0) {
            // 返回一个数组处理栏目名称和id
            console.log(data,"栏目data")
            const arr = [];

            //筛选扩展字段
            for (const item of data.result.content) {
                // 扩展字段长度不等于0
                
                if (item.extFieldsList.length != 0) {
                    const tags_name = item.extFieldsList.find(e => e.label == '标签名');
                    
                    const tags_id = item.extFieldsList.find(e => e.label == '分类id');
                    // 获取栏目类型
                    let tags_type = item.extFieldsList.find(e => e.label == '栏目类型');
                    tags_type = tags_type ? tags_type.fieldValue : false;

                    // 获取栏目图片
                    let tags_img = item.extFieldsList.find(e => e.label == '栏目图片');
                    tags_img = tags_img ? tags_img.fieldValue : false;
                    console.log("获取扩展字段",tags_type)
                    // 如果同时不为空
                    if (tags_name && tags_id) {
                        arr.push({
                            id: item.id,
                            tags_name: tags_name.fieldValue,
                            tags_id: tags_id.fieldValue,
                            tags_type,
                            tags_img
                        });
                    }
                }
            }
            return {
                state: 1,
                message: "获取初始化数据成功！",
                data: arr
            }

        } else {
            return {
                state: 0,
                message: "初始化失败！0"
            }
        }

    } catch (error) {
        console.log(error);
        return {
            state: 0,
            message: "初始化失败！"
        }
    }
}

// 根据分类id获取文章列表
export async function getArticles(id, page = 1) {
    try {
        const config = {
            method: 'get',
            url: `https://yxwpubmod.hntv.tv/mobile/cms/articles?channelId=${id}&tenantId=hnr&pageNo=${page}&pageSize=30`,
        };

        const { data } = await axios(config);
        if (data.code === 0) {
            // 返回一个数组处理栏目名称和id
            const arr = [];

            //筛选扩展字段
            for (const item of data.result.content) {
                arr.push(handleArticles(item))
            }
            return {
                state: 1,
                message: "获取列表成功！",
                data: {
                    channelId: id,
                    // 当前页数
                    page: data.result.pageNo,
                    // 总页数
                    totalPage: data.result.totalPage,
                    list: arr
                }
            }

        } else {
            return {
                state: 0,
                message: "获取列表失败！1"
            }
        }

    } catch (error) {
        console.log(error);
        return {
            state: 0,
            message: "获取列表失败！2"
        }
    }
}


// 获取首页头条(融媒热头条)
export async function getTopAtricles() {
    try {
        const config = {
            method: 'get',
            url: `https://yxwpubmod.hntv.tv/mobile/cms/articles?channelId=1605036848637362177&tenantId=hnr&pageNo=1&pageSize=3`,
        };

        const { data } = await axios(config);
        if (data.code === 0) {
            // 返回一个数组处理栏目名称和id
            const arr = [];

            //筛选扩展字段
            for (const item of data.result.content) {
                // 只是筛选为置顶的头条
                // if (item.topFlag === "1") {
                    arr.push(handleArticles(item))
                // }

            }
            return {
                state: 1,
                message: "获取列表成功！",
                data: {
                    channelId: "1605036848637362177",
                    // 当前页数
                    page: data.result.pageNo,
                    // 总页数
                    totalPage: data.result.totalPage,
                    list: arr
                }
            }

        } else {
            return {
                state: 0,
                message: "获取列表失败！1"
            }
        }

    } catch (error) {
        console.log(error);
        return {
            state: 0,
            message: "获取列表失败！2"
        }
    }
}




// 获取首页推荐文章（新闻节点下的河南24小时）
export async function getRecommendAtricles(page = 1) {
    try {
        const config = {
            method: 'get',
            url: `https://yxwpubmod.hntv.tv/mobile/cms/articles?channelId=1185134428796620800&tenantId=hnr&pageNo=${page}&pageSize=30`,
        };

        const { data } = await axios(config);
        if (data.code === 0) {
            // 返回一个数组处理栏目名称和id
            const arr = [];

            //筛选扩展字段
            for (const item of data.result.content) {
                // 只是筛选
                arr.push(handleArticles(item))

            }
            return {
                state: 1,
                message: "获取列表成功！",
                data: {
                    channelId: "1185134428796620800",
                    // 当前页数
                    page: data.result.pageNo,
                    // 总页数
                    totalPage: data.result.totalPage,
                    list: arr
                }
            }

        } else {
            return {
                state: 0,
                message: "获取列表失败！9"
            }
        }

    } catch (error) {
        console.log(error);
        return {
            state: 0,
            message: "获取列表失败！8"
        }
    }
}

// 获取首页轮播图
export async function getLunbo() {
    try {
        const config = {
            method: 'get',
            url: `https://yxwpubmod.hntv.tv/mobile/cms/articles?channelId=1203845251052212224&tenantId=hnr&pageNo=1&pageSize=6`,
        };

        const { data } = await axios(config);
        if (data.code === 0) {
            // 返回一个数组处理栏目名称和id
            const arr = [];

            //筛选扩展字段
            for (const item of data.result.content) {
                // 只是筛选
                arr.push(handleArticles(item))
            }
            return {
                state: 1,
                message: "获取列表成功！",
                data: {
                    channelId: "1203845251052212224",
                    // 当前页数
                    page: data.result.pageNo,
                    // 总页数
                    totalPage: data.result.totalPage,
                    list: arr
                }
            }

        } else {
            return {
                state: 0,
                message: "获取列表失败！237"
            }
        }

    } catch (error) {
        console.log(error);
        return {
            state: 0,
            message: "获取列表失败！245"
        }
    }
}


function handleArticles(item) {
    // 无图3、三图2、双图4、大图1、单图0
    let articleType = 3;
    if (item.coverType !== 'null' && item.coverType) {
        articleType = isNaN(+item.coverType) ? 0 : +item.coverType;
    } else {
        articleType = handleArticleType(item.extFieldsList)
    }
    // console.log("title",item.title)
    // console.log("item.forwardingUrl",  item.forwardingUrl)
    // console.log("item.linkTo",  item.linkTo)
    // console.log("item.id",  item.id)
    let length=item.forwardingUrl.split("/").length
    item.forwardingUrl= `https://5g.hnr.cn/news/${item.articleType}/${item.id}`

    
    if(item.articleType==5 && item.linkTo.indexOf("hnr.cn")>0){
        item.linkTo=`https://5g.hnr.cn/news/${item.articleType}/${item.linkTo.split("/")[item.linkTo.split("/").length-1]}`
       
    }
    console.log("最后链接", item.articleType == 5 ? item.linkTo : item.forwardingUrl)
    return {
        id: item.id,
        title: item.title,
        // 描述
        des: item.summary,
        // 来源
        from: item.origin,
        // 文章类型,默认类型级别最高,其次扩展类型
        articleType: articleType,
        // 是否是顶置文章
        top: item.topFlag === "1" ? true : false,
        publishDate: item.publishDate,
        // 封面图
        coverImagesList: item.coverImagesList.map((e) => {
            return {
                url: e.url,
                des: e.desc,
                // 是否是封面图
                coverBool: e.coverBool
            }
        }),
        url: item.articleType == 5 ? item.linkTo : item.forwardingUrl,
        type: item.articleType
    }
}

function handleArticleType(ext) {
    const res = ext.find(e => e.label == '扩展类型');
    if (res) {
        // 转为字符串
        return +res.fieldValue;
    } else {
        return 0
    }
}